import { type Index } from '../types/IndexType.ts'
import keyValueBy from './keyValueBy.ts'

/** Filters an object by a predicate. Does not catch exceptions thrown by the predicate. */
const filterObject = <T>(obj: Index<T>, predicate: (key: string, value: T) => boolean) =>
  keyValueBy(obj, (key, value) => (predicate(key, value) ? { [key]: value } : null))

export default filterObject
